import { Component, Input } from "@angular/core";
import { Observable } from "rxjs";
import { PaysafeService } from "@modules/paysafe/services/paysafe.service";
import { CustomModal } from "@modules/core/components/base-modals";

@Component({
	templateUrl: "./card-deposit-pending.component.html",
	styleUrls: ["./../success-screen.component.scss", "card-deposit-pending.component.scss"],
	standalone: false
})
export class CardDepositPendingComponent extends CustomModal {
	@Input() public header: string = "";
	public descriptionKey$: Observable<string> = this.paysafeService.pendingScreenDescription$;

	public constructor(private paysafeService: PaysafeService) {
		super();
	}
}
